import useSWR from 'swr';
import { authenticatedFetcher } from '@/lib/swr';
import { PP_BASE_URL } from '@/lib/env';
import type { ApiResponse } from '@/types/api-response';

export interface PartnershipCharterResponse {
  studentNumber: string;
  studentName: string;
  studentEmiratesId: string;
  studentPhone?: string | null;
  studentEmail?: string | null;
  studentAddress?: string | null;
  hasValidStudentAddress: boolean;
  parentName: string;
  parentEmiratesId: string;
  schoolId?: string | null;
  schoolName: string;
  schoolYear: string;
  schoolAddress: string;
  schoolPhone?: string | null;
  schoolEmail?: string | null;
  isSigned: boolean;
  signedDate?: string | null;
}

export function useGetCharter(studentNumber?: string | null, academicYear?: string | null, locale?: string) {
  const params = new URLSearchParams();
  if (studentNumber) params.set('studentNumber', studentNumber);
  if (academicYear) params.set('academicYear', academicYear);
  if (locale) params.set('locale', locale);
  const key = studentNumber ? `${PP_BASE_URL}/charter?${params.toString()}` : null;

  const {
    data: response,
    error,
    isLoading,
    mutate: mutateCharter,
  } = useSWR<ApiResponse<PartnershipCharterResponse>>(key, authenticatedFetcher, {
    revalidateOnMount: true,
    revalidateOnFocus: false,
    dedupingInterval: 5000,
    shouldRetryOnError: (err: any) => err?.status !== 404,
  });

  return {
    charterRecord: response?.data ?? null,
    isSigned: Boolean(response?.data?.isSigned),
    isLoading,
    error,
    mutateCharter,
  };
}
